export default {
    SET_USER: "setUser",
    SET_CHALLENGE_CLASS: "setChallengeClass",
    SET_CHALLENGES_CLASS: "setChallengesClass",
    SET_MYCLASSES: "setMyClasses",
    SET_CLASSROOM: "setClassroom"
}
